import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const LOOP_API = `${getApiBaseUrl()}/loop`;

const getPlatformCostConfig = (groupId) =>
  httpService({
    url: `${LOOP_API}/platform-cost/groups/${groupId}`,
    method: 'get',
  });

const upsertPlatformCostConfig = (payload) =>
  httpService({
    url: `${LOOP_API}/platform-cost`,
    method: 'put',
    data: payload,
  });

const updatePlatformCostLocations = (payload) =>
  httpService({
    url: `${LOOP_API}/platform-cost/locations`,
    method: 'put',
    data: payload,
  });

const platformCostService = {
  getPlatformCostConfig,
  upsertPlatformCostConfig,
  updatePlatformCostLocations,
};

export default platformCostService;
